'use client';

import React from 'react';

import { HomeFeedView } from '@/components/feed';

/** `/home` — the combined feed (videos + news interleaved). */
export const HomePage: React.FC = () => <HomeFeedView kind="all" />;
